import { isEqual } from 'lodash';

const BAD_REQUEST = 400;

export const getApiCommonErrMsg = (err: {
  status: number;
  meta: { code: string; message: string };
}): string => {
  if (!isEqual(BAD_REQUEST, err?.status)) {
    return;
  }

  return err.meta?.message;
};
